import { functions, groupBy, orderBy, uniqBy } from "lodash";
import { Item__Atividades, Item__UnidadeMedida, ItemPropriedades } from "../../../../../services/atividades/GET";
import { mascaraHectares } from "../../../../../utils";
import { area } from "@turf/turf";
import { talhoesFinalizados } from "./dados_modais";
import { extrairUnidade } from "../../linhaDoTempo/components/cadastro/components/addInsumo/meta";

function obterSomatoriaDeAtvsConcluidas(data_propriedades: ItemPropriedades[], data_atividades: Item__Atividades[]) {

    //@ts-ignore
    let todos_talhoes_da_propriedade = (data_propriedades ?? []).map(i => i.talhao)?.flat()?.filter(j => j.cod_talhao === null);

    let atividades_por_talhao = (todos_talhoes_da_propriedade ?? []).map(({ cod, area, cod_propriedade, nome }) => {
        let atvs_planejadas = (data_atividades ?? []).filter(i => i.cod_tipo === 1 && i.cod_talhao === cod);
        let atvs_executadas_andamento = (data_atividades ?? []).filter(i => i.cod_tipo === 2 && Boolean(i.concluido) === false && i.cod_talhao === cod);
        let atvs_concluidas = (data_atividades ?? []).filter(i => i.cod_tipo === 1 && Boolean(i.concluido) === true && i.cod_talhao === cod);

        function atvVinculadoIsConcluida(cod_atvidade: number) {
            let encontrar = (atvs_planejadas ?? []).find(i => i.cod === cod_atvidade);
            return encontrar ? Boolean(encontrar?.concluido) : false;
        }

        return {
            cod_talhao: cod,
            nome_talhao: nome,
            cod_propriedade: cod_propriedade,
            area_talhao: Number(area),
            atvs_planejadas: atvs_planejadas,
            atvs_executadas_andamento: atvs_executadas_andamento.filter(i => atvVinculadoIsConcluida(i.cod_atividade) === false),
            atvs_concluidas: atvs_concluidas,
        }
    });

    let somatoria = (atividades_por_talhao ?? []).map(({ cod_talhao, nome_talhao, cod_propriedade, area_talhao, atvs_planejadas, atvs_concluidas, atvs_executadas_andamento }) => {
        let qtd_atvs_planejada = (atvs_planejadas ?? []).length;
        let qtd_atvs_concluidas = (atvs_concluidas ?? []).length;
        let area_atvs_andamento = atvs_executadas_andamento.length > 0 ? (atvs_executadas_andamento ?? []).reduce((acc, item) => acc + Number(item.area_executada), 0) : 0;
        return {
            cod_talhao: cod_talhao,
            nome_talhao: nome_talhao,
            cod_propriedade: cod_propriedade,
            area_talhao: area_talhao,
            area_planejada: area_talhao * qtd_atvs_planejada,
            area_concluida: area_talhao * qtd_atvs_concluidas,
            area_proporcional_concluida: qtd_atvs_concluidas > 0 ? (area_talhao * qtd_atvs_concluidas) / qtd_atvs_planejada : 0,
            area_proporcional_andamento: area_atvs_andamento > 0 ? (area_atvs_andamento / qtd_atvs_planejada) : 0
        }
    })

    return somatoria;
}

//#region Progresso geral
export function progressoGeral(data_atividades: Item__Atividades[], data_propriedades: ItemPropriedades[], cod_propriedade_selecionada?: number, cod_talhao_selecionado?: number): [number, number, number] {

    //@ts-ignore
    let todos_talhoes_da_propriedade = (data_propriedades ?? []).map(i => i.talhao)?.flat()?.filter(j => j.cod_talhao === null);

    function obterTalhoesDaPropriedade() {
        if (cod_propriedade_selecionada && !cod_talhao_selecionado) {
            return (todos_talhoes_da_propriedade ?? [])?.filter(i => i.cod_propriedade === cod_propriedade_selecionada);
        }
        if (cod_propriedade_selecionada && cod_talhao_selecionado) {
            return (todos_talhoes_da_propriedade ?? [])?.filter(i => i.cod === cod_talhao_selecionado);
        }
        return todos_talhoes_da_propriedade;
    }

    const AREA_TOTAL_TALHOES = Math.ceil((obterTalhoesDaPropriedade() ?? []).reduce((acc, item) => acc + Number(item.area), 0));

    let somatoria = obterSomatoriaDeAtvsConcluidas(data_propriedades, data_atividades);

    let soma_areas_concluidas = (somatoria ?? []).reduce((acc: number, item) => acc + Number(item.area_proporcional_concluida), 0);
    let soma_areas_andamento = (somatoria ?? []).reduce((acc: number, item) => acc + Number(item.area_proporcional_andamento), 0);

    const PORCETAGEM_CONCLUIDA = (soma_areas_concluidas / AREA_TOTAL_TALHOES) * 100;
    const PORCETAGEM_ANDAMENTO = (soma_areas_andamento / AREA_TOTAL_TALHOES) * 100;
    const PORCENTEGEM_PENDENTE = 100 - (PORCETAGEM_CONCLUIDA + PORCETAGEM_ANDAMENTO);

    return [
        PORCETAGEM_CONCLUIDA, //concluído
        PORCETAGEM_ANDAMENTO, //em andamento
        PORCENTEGEM_PENDENTE //pendente
    ]
};

//#region Prazos
export function prazos(data_atividades: Item__Atividades[]) {


    function checarVinculo(item: Item__Atividades) {
        if (item.cod_tipo === 2 && item.cod_atividade !== null) {
            let planejada = (data_atividades ?? []).find(i => i.cod === item.cod_atividade);
            return planejada !== undefined;
        }
        return false;
    }

    const atvs_executadas = (data_atividades ?? []).filter(i => checarVinculo(i));
    const atvs_execucoes = (atvs_executadas ?? [])?.map((i) => {
        return {
            ...i,
            andamentos: i.andamentos?.map(j => {
                return { ...j, ...i }
            })
        }
        //@ts-ignore
    })?.map(i => i.andamentos)?.flat();

    const cods_vinculadas = (atvs_execucoes ?? []).map(i => i.cod_atividade);
    const atvs_planejadas = (data_atividades ?? []).filter(i => i.cod_tipo === 1 && !(cods_vinculadas.includes(i.cod)));

    let prazos_atvs = (atvs_execucoes ?? []).map(({ data_final, cod_atividade }) => {

        let planejada = (data_atividades ?? []).find(i => i.cod === cod_atividade);

        function obter() {
            if (data_final < planejada?.data_inicio && data_final < planejada?.data_final) {
                return 'Adiantado'
            }
            if (data_final >= planejada?.data_inicio && data_final <= planejada?.data_final) {
                return 'No prazo'
            }
            if (data_final > planejada?.data_final && data_final > planejada?.data_inicio) {
                return 'Atrasado'
            }
            else return ''
        }

        return {
            prazo: obter()
        }
    });

    let contagem_antes_prazo = (prazos_atvs ?? [])?.filter(i => i.prazo === 'Adiantado')?.length;
    let contagem_dentro_prazo = (prazos_atvs ?? [])?.filter(i => i.prazo === 'No prazo')?.length;
    let contagem_depois_prazo = (prazos_atvs ?? [])?.filter(i => i.prazo === 'Atrasado')?.length;
    let contagem_pendente = (atvs_planejadas?.length ?? 0) - (contagem_antes_prazo + contagem_dentro_prazo + contagem_antes_prazo);

    const TOTAL_ATVS = atvs_execucoes?.length ?? 0;
    // const TOTAL_ATVS_PLANAJEDAS = atvs_planejadas?.length ?? 0;
    const ADIANTADO: number = contagem_antes_prazo === 0 ? 0 : Number(((contagem_antes_prazo / TOTAL_ATVS) * 100)?.toFixed(2));
    const NO_PRAZO: number = contagem_dentro_prazo === 0 ? 0 : Number(((contagem_dentro_prazo / TOTAL_ATVS) * 100)?.toFixed(2));
    const ATRASADO: number = contagem_depois_prazo === 0 ? 0 : Number(((contagem_depois_prazo / TOTAL_ATVS) * 100)?.toFixed(2));
    const PENDENTE = 100 - (ADIANTADO + NO_PRAZO + ATRASADO);

    return {
        porcentagens: [Number(NO_PRAZO), Number(ADIANTADO), Number(ATRASADO)],
        quantidades: [contagem_dentro_prazo, contagem_antes_prazo, contagem_depois_prazo, contagem_pendente]
    }

};


//#region Detalhamento
export function detalhamentos(data_atividades: Item__Atividades[], data_propriedades: ItemPropriedades[], cod_propriedade_selecionada: number, cod_talhao_selecionado: number, cod_subarea_selecionada: number): {
    talhoes_finalizados: number,
    qtd_talhoes: number,
    qtd_execucoes: number,
    qtd_planejadas: number,
    area_concluida: string,
    area_total: string
} {

    //@ts-ignore #TALHÕES
    let talhoes = (data_propriedades?.flat() ?? []).map(i => i.talhao)?.flat();
    let talhoes_com_safra = (talhoes ?? [])?.filter(i => i.cod_safra !== null);

    function obterListaTalhoes() {
        if (cod_propriedade_selecionada && !cod_talhao_selecionado) {
            return (talhoes_com_safra ?? [])?.filter(i => i.cod_propriedade === cod_propriedade_selecionada);
        }
        if (cod_propriedade_selecionada && cod_talhao_selecionado) {
            if (cod_subarea_selecionada) {
                return (talhoes_com_safra ?? [])?.filter(i => i.cod === cod_talhao_selecionado);
            }
            return (talhoes_com_safra ?? [])?.filter(i => i.cod === cod_talhao_selecionado || i.cod_talhao === cod_talhao_selecionado);
        }
        return talhoes_com_safra;
    }

    const TOTAL_TALHOES = (obterListaTalhoes() ?? [])?.length ?? 0;

    //#FINALIZADOS
    let talhoes_finalizados = (talhoesFinalizados(data_atividades, data_propriedades)).finalizados.length;

    //@ts-ignore #EXECUCOES
    let executadas = (data_atividades ?? []).filter(i => i.cod_tipo === 2 && i.delete_time === null)?.map(i => i.andamentos ?? [])?.flat();

    //@ts-ignore #planejedas
    let planejadas = (data_atividades ?? []).filter(i => i.cod_tipo === 1 && i.delete_time === null);
    let planejadas_unicas = uniqBy(planejadas, 'descricao')

    //@ts-ignore #AREA TOTAL
    let soma_areas = (obterListaTalhoes() ?? [])?.reduce((acc, item) => Number(item.area) + acc, 0);

    //@ts-ignore #AREA CONCLUÍDA
    function areaConcluida() {
        let somatoria = obterSomatoriaDeAtvsConcluidas(data_propriedades, data_atividades);
        let area_concluida = (somatoria ?? []).reduce((acc, i) => acc + Number(i.area_proporcional_concluida), 0);
        let area_andamento = (somatoria ?? []).reduce((acc, i) => acc + Number(i.area_proporcional_andamento), 0);
        return Number(area_concluida) + Number(area_andamento);
    }

    return {
        talhoes_finalizados: talhoes_finalizados,
        qtd_talhoes: TOTAL_TALHOES,
        qtd_execucoes: executadas?.length,
        qtd_planejadas: planejadas_unicas?.length,
        area_concluida: areaConcluida()?.toFixed(2),
        area_total: soma_areas?.toFixed(2)
    }
};

//#region Propriedes/talhoes
export function progressoTalhoes(data_atividades: Item__Atividades[], data_propriedades: ItemPropriedades[], cod_propriedade?: number, cod_talhao?: number): {
    key: string,
    nome: string,
    cod_talhao?: number,
    cod_propriedade?: number,
    cod_filtro: number,
    atividades: any[],
    area_executada: number,
    area_total: number,
    porcentagem: number
}[] {

    let somatoria = obterSomatoriaDeAtvsConcluidas(data_propriedades, data_atividades);

    if (Number(cod_talhao) > 0) {

        let atvs_do_talhao = orderBy((data_atividades ?? []), 'data_inicio', 'asc').filter(i => (i.cod_talhao === cod_talhao) && (i.cod_tipo === 1));

        let estrututura_talhao = (atvs_do_talhao ?? []).map((i, idx) => {
            return {
                key: i.descricao + '_' + idx,
                nome: (i.descricao).toLowerCase(),
                cod_talhao: i.cod_talhao,
                cod_propriedade: i.cod_propriedade,
                cod_filtro: i.cod_talhao, //filtrar por talhao no modal de detalhes
                atividades: [],
                area_executada: Number(i.area_executada),
                area_total: Number(i.area),
                porcentagem: Number(i.porcentagem_executada)
            }
        })
        return estrututura_talhao ?? [];
    }

    if (Number(cod_propriedade) > 0) {
        let somatoria_propriedade = somatoria?.filter(i => i.cod_propriedade === cod_propriedade);

        let estrutura_propriedades = (somatoria_propriedade ?? []).map((i, index) => {
            return {
                key: i.cod_talhao + '_' + index,
                nome: i.nome_talhao,
                atividades: [],
                cod_talhao: i.cod_talhao,
                cod_propriedade: i.cod_propriedade,
                cod_filtro: i.cod_talhao, //filtrar por talhao no modal de detalhes
                area_executada: i.area_proporcional_concluida,
                area_total: i.area_talhao,
                porcentagem: (i.area_proporcional_concluida / i.area_talhao) * 100
            }
        })
        return estrutura_propriedades ?? []
    }

    let agrupar_por_propriede = Object.entries(groupBy(somatoria, 'cod_propriedade')).map(([cod_propriedade, lista_atividades]) => {
        let soma_areas = (lista_atividades ?? []).reduce((acc, i) => acc + Number(i.area_talhao), 0);
        let area_concluida = (lista_atividades ?? []).reduce((acc, i) => acc + Number(i.area_proporcional_concluida), 0);
        return {
            cod_propriedade: Number(cod_propriedade),
            area_total: soma_areas,
            area_concluida: area_concluida,
            lista_atividade: lista_atividades
        }
    });

    function nomePropriedade(cod_propriedade: number) {
        return (data_propriedades ?? []).find(i => i.cod === cod_propriedade)?.nome;
    }

    let estrutura = (agrupar_por_propriede ?? []).map((item, index) => {
        return {
            key: item.cod_propriedade + '_' + index,
            nome: nomePropriedade(item?.cod_propriedade),
            cod_propriedade: item?.cod_propriedade,
            atividades: item.lista_atividade,
            area_executada: item.area_concluida,
            area_total: item.area_total,
            cod_filtro: item.cod_propriedade, //filtrar por propriede no modal de detalhes
            porcentagem: (item.area_concluida / item.area_total) * 100
        }
    })

    return estrutura ?? [];
};


//#region INSUMOS
export type InsumosSaida = {
    nome_insumo: string,
    filtro: 'Por peso' | 'Por volume' | 'Por sementes' | '',
    lista_insumos: any[],
    quantidade_total: number,
    nome_medida: string | 't' | 'kg' | 'g' | 'L' | 'ml' | 'sementes' | 'M de sementes',
    quantidade_convertida: number,
    medida_convertida: string | 't' | 'kg' | 'g' | 'L' | 'ml' | 'sementes' | 'M de sementes',
    cod_insumo?: number,
    soma_dosagem?: number,
    cod_tipo?: number,
    calculo_dosagem?: string
};

function obterCodInsumo(cod_tipo: number, lista: any[]) {
    if (!lista || lista.length === 0) return null;
    const first = lista[0];
    if (cod_tipo === 2) return first?.cod_variedade_hibrido ?? null;
    if (cod_tipo === 3) return first?.cod_fertilizante ?? null;
    if ([1, 4, 5, 6, 7, 8, 9].includes(cod_tipo)) return first?.cod_produto ?? null;
    return null;
}
function normalizarMedidas(medida: string) {
    if (medida === 't' || medida === 'T' || medida === 'ton' || medida === 't/ha' || medida === 'T/ha' || medida === 'ton/ha') {
        return 'kg';
    }
    if (medida === 'g' || medida === 'G' || medida === 'g/ha' || medida === 'G/ha') {
        return 'kg';
    }
    if (medida === 'kg' || medida === 'kg/ha' || medida === 'KG' || medida === 'KG/ha' || medida === 'kG' || medida === 'kG/ha' || medida === 'Kg' || medida === 'Kg/ha') {
        return 'kg';
    }
    if (medida === 'ml' || medida === 'ML' || medida === 'mL' || medida === 'Ml' || medida === 'ml/ha' || medida === 'ML/ha' || medida === 'mL/ha' || medida === 'Ml/ha') {
        return 'L';
    }
    if (medida === 'L' || medida === 'l' || medida === 'L/ha' || medida === 'l/ha') {
        return 'L';
    }
    if (medida === 'sementes' || medida === 'Sementes' || medida === 'sementes/ha' || medida === 'Sementes/ha') {
        return 'sementes';
    }
    return medida;
}
/**converte quantidade sólida para KG e liquida para L */
function normalizarQuantidade(quantidade: number, medida: string) {
    if (medida === 't' || medida === 'T' || medida === 'ton' || medida === 't/ha' || medida === 'T/ha' || medida === 'ton/ha') {
        return Number((Number(quantidade) * 1000).toFixed(2));
    }
    if (medida === 'g' || medida === 'G' || medida === 'g/ha' || medida === 'G/ha') {
        return Number((Number(quantidade) / 1000).toFixed(2));
    }
    if (medida === 'ml' || medida === 'ML' || medida === 'mL' || medida === 'Ml' || medida === 'ml/ha' || medida === 'ML/ha' || medida === 'mL/ha' || medida === 'Ml/ha') {
        return Number((Number(quantidade) / 1000).toFixed(2));
    }
    return Number(quantidade);
}

function tipoEstado(cod_medida: number) {
    let por_volume = [1, 2, 12];
    let por_peso = [3, 4, 5, 6, 7, 8, 10, 11];
    let por_semente = [9];
    // let por_dose = [12];

    let is_por_peso = por_peso?.includes(cod_medida);
    let is_por_semente = por_semente?.includes(cod_medida);
    // let is_por_dose = por_dose?.includes(cod_medida);

    if (is_por_semente) {
        return ['Por sementes', 'sementes'];
    }
    // if (is_por_dose) {
    //     return ['Por dose', 'dose'];
    // }
    return is_por_peso ? ['Por peso', 'peso'] : ['Por volume', 'volume']
};


export function insumos(data_atividades: Item__Atividades[], data_unidades_medida: Item__UnidadeMedida[], tipo_atv: 'planejada' | 'executada'): InsumosSaida[] {

    function obterNomeMedida(cod_medida: number) {
        return (data_unidades_medida ?? []).find(i => i.cod === cod_medida)?.nome ?? '?';
    }
    function obterCodInsumoMain(cod_tipo: number, cod_variedade_hibrido: number, cod_fertilizante: number, cod_produto: number,) {
        if (cod_tipo === 2 || cod_tipo === 9) return cod_variedade_hibrido;
        if (cod_tipo === 3) return cod_fertilizante;
        if ([1, 4, 5, 6, 7, 8].includes(cod_tipo)) return cod_produto;
        return null;
    }

    let cod_tipo_atividade = tipo_atv === 'planejada' ? 1 : 2;

    let atividades_por_tipo__01 = (data_atividades ?? []).filter(i => i.cod_tipo === cod_tipo_atividade);

    let add_cod_atv__01_5 = (atividades_por_tipo__01 ?? []).map((i) => {
        return {
            ...i,
            andamentos: (i.andamentos ?? []).map((j) => {
                return {
                    ...j,
                    cod_atividade: i.cod
                }
            })
        }
    });

    //@ts-ignore
    let apenas_andamentos__02 = (add_cod_atv__01_5 ?? []).map(i => i.andamentos)?.flat();

    let add_area__03 = (apenas_andamentos__02 ?? []).map((i) => {
        return {
            ...i,
            insumos: (i.insumos ?? []).map((j) => {
                return {
                    ...j,
                    area_andamento: i.area,
                    cod_usuario: i.cod_usuario,
                    operadores_planejada: i.operadores,
                    cod_atividade: i.cod_atividade,
                    medida_inoculante: extrairUnidade(j?.calculo_dosagem) ?? null
                }
            })
        }
    })
    //@ts-ignore //lista apenas os insumos de todas as atividades
    let apenas_insumos__04 = (add_area__03 ?? []).map(i => i.insumos)?.flat().filter(i => i);

    let add_referencia__05 = (apenas_insumos__04 ?? []).map(i => { return { ...i, filtro: tipoEstado(i.cod_medida)?.[0], referencia: i.insumo_nome + '_____' + tipoEstado(i.cod_medida)?.[1] } })

    let agrupar_por_nome_e_tipo__06 = groupBy(add_referencia__05, 'referencia');

    let listar_insumos_totalizados__07 = (Object.entries(agrupar_por_nome_e_tipo__06) ?? []).map(([ref_nome_insumo, lista_insumos]) => {
        let tipo_filtro = lista_insumos?.[0]?.filtro;
        let cod_tipo = lista_insumos?.[0]?.cod_tipo;
        let cod_produto = lista_insumos?.[0]?.cod_produto;
        let cod_fertilizante = lista_insumos?.[0]?.cod_fertilizante;
        let cod_variedade_hibrido = lista_insumos?.[0]?.cod_variedade_hibrido;
        let insumos_normalizados = (lista_insumos ?? []).map(i => {
            let unidade_medida_nome = i?.cod_tipo === 8 ? i?.medida_inoculante : obterNomeMedida(i?.cod_medida)
            return {
                ...i,
                quandidade_normalizada: normalizarQuantidade(i?.quantidade, unidade_medida_nome)
            }
        })
        let quantidade_total = (insumos_normalizados ?? []).reduce((acc, i) => acc + Number(i.quandidade_normalizada), 0);
        let nome_medida = tipo_filtro === 'Por sementes' ? 'de sementes' : (tipo_filtro === 'Por peso' ? 'Kg' : 'L');

        return {
            nome_insumo: ref_nome_insumo?.split('_____')?.[0],
            filtro: tipo_filtro,
            lista_insumos: insumos_normalizados,
            quantidade_total: Number(quantidade_total?.toFixed(2)),
            nome_medida: nome_medida,
            quantidade_convertida: converterQuantidade(quantidade_total, nome_medida).quantidade_convertida,
            medida_convertida: converterQuantidade(quantidade_total, nome_medida).medida_convertida,
            cod_tipo: lista_insumos?.[0]?.cod_tipo,
            calculo_dosagem: lista_insumos?.[0]?.calculo_dosagem,
            soma_dosagem: (lista_insumos ?? []).reduce((acc, i) => acc + Number(i.dosagem), 0),
            cod_insumo: obterCodInsumoMain(cod_tipo, cod_variedade_hibrido, cod_fertilizante, cod_produto)
        }
    });

    return orderBy(listar_insumos_totalizados__07, 'quantidade_total', 'desc') ?? [];
}

//#region Detalhes Insumos
type InsumoLista = {
    cod: number;
    ordem: number | null;
    dosagem: number;
    cod_tipo: number;
    cod_medida: number;
    observacao: string | null;
    quantidade: number;
    cod_produto: number | null;
    create_time: string; // ISO Date
    create_user: string;
    delete_time: string | null;
    insumo_nome: string;
    update_time: string | null;
    update_user: string | null;
    cod_tecnologia: number | null;
    calculo_dosagem: number | null;
    cod_fertilizante: number;
    cod_variedade_hibrido: number | null;
    cod_atividade_andamento: number;
    composicao: any[];
    cod_insumo: number;
}

export type DetalhesInsumosSaida = {
    cod_talhao?: number,
    cod_insumo: number,
    nome_talhao: string,
    nome_propriedade: string,
    lista_atividades: any[],
    insumos: any[],
    totalizar_qtd_insumos: number,
    porcentagem_insumo: number,
    unidade_medida: string
}

export function detalhesInsumos(
    data_atividades: Item__Atividades[],
    cod_insumo: number,
    tipo_atv: string | 'Planejados' | 'Executados',
    data_propriedades: ItemPropriedades[],
    data_unidades_medida: Item__UnidadeMedida[],
    dados_insumo: { quantidade_total: number, quantidade_convertida: number, nome_medida: string, lista_insumos: any }
): DetalhesInsumosSaida[] {

    const cod_tipo_atv = tipo_atv === 'Planejados' ? 1 : 2;
    const atividades_ativas = (data_atividades ?? []).filter(i => i.cod_tipo === cod_tipo_atv && i.delete_time === null);
    //@ts-ignore
    let todos_talhoes_da_propriedade = (data_propriedades ?? []).map(i => i.talhao)?.flat()?.filter(j => j.cod_talhao === null);
    let quantidade_total = (dados_insumo?.lista_insumos ?? [])?.reduce((acc, item) => acc + item.quandidade_normalizada, 0) ?? 0;

    function obterInfoTalhao(cod_atividade: number) {
        let atividade = (atividades_ativas ?? []).find(i => i.cod === cod_atividade);
        let nome_atv_executada = (data_atividades ?? []).find(i => i.cod === atividade?.cod_atividade);
        let info_talhao = (todos_talhoes_da_propriedade ?? []).find(i => i.cod == atividade?.cod_talhao);
        let nome_propriedade = (data_propriedades ?? []).find(i => i.cod === info_talhao?.cod_propriedade)?.nome;

        return {
            cod_talhao: atividade?.cod_talhao,
            nome_talhao: info_talhao?.nome ?? "???",
            nome_propriedade: nome_propriedade,
            andamentos: atividade?.andamentos,
            nome_atividade: cod_tipo_atv === 1 ? atividade?.descricao : nome_atv_executada?.descricao,
            data_inicio_atividade: atividade?.data_inicio,
            data_final_atividade: atividade?.data_final,

        }
    };
    function unidadeNormalizada(filtro: string) {
        switch (filtro) {
            case 'Por peso':
                return 'Kg'
            case 'Por volume':
                return 'L'
            case 'Por sementes':
                return 'de sementes'
            default:
                return '??';
        }
    }

    let add_info_talhao__01 = (dados_insumo?.lista_insumos ?? []).map((item) => {
        return {
            ...item,
            cod_talhao: obterInfoTalhao(item.cod_atividade)?.cod_talhao,
            nome_talhao: obterInfoTalhao(item.cod_atividade)?.nome_talhao,
            nome_propriedade: obterInfoTalhao(item.cod_atividade)?.nome_propriedade,
            nome_atividade: obterInfoTalhao(item.cod_atividade)?.nome_atividade,
            data_inicio_atividade: obterInfoTalhao(item.cod_atividade)?.data_inicio_atividade
        }
    });

    let agrupar_insumos_por_talhao__02 = groupBy(add_info_talhao__01, 'nome_talhao');

    let listar_por_talhao__03 = (Object.entries(agrupar_insumos_por_talhao__02) ?? []).map(([nome_talhao, lista_insumos]) => {
        let quantidade_total_normalizada = (lista_insumos ?? []).reduce((acc, item) => acc + item.quandidade_normalizada, 0);
        let quantidade_convertida = converterQuantidade(quantidade_total_normalizada, unidadeNormalizada(lista_insumos?.[0]?.filtro))
        let porcentagem = ((quantidade_total_normalizada / quantidade_total) * 100)?.toFixed(2);
        return {
            cod_talhao: lista_insumos?.[0]?.cod_talhao,
            cod_insumo: lista_insumos?.[0]?.cod_insumo,
            nome_talhao: nome_talhao,
            nome_propriedade: lista_insumos?.[0]?.nome_propriedade,
            lista_atividades: lista_insumos,
            insumos: lista_insumos,
            totalizar_qtd_insumos: quantidade_convertida?.quantidade_convertida,
            porcentagem_insumo: Number(porcentagem),
            unidade_medida: quantidade_convertida?.medida_convertida,
        }
    });

    return orderBy(listar_por_talhao__03, 'totalizar_qtd_insumos', 'desc') ?? [];
}









//#region Converter quantidade
export function converterQuantidade(quantidade: number, medida: string) {

    if (medida === 't' || medida === 'T' || medida === 'ton' || medida === 't/ha' || medida === 'T/ha' || medida === 'ton/ha') {
        return {
            quantidade_convertida: Number(quantidade?.toFixed(2)),
            medida_convertida: 't'
        }
    }
    if (medida === 'kg' || medida === 'kg/ha' || medida === 'KG' || medida === 'KG/ha' || medida === 'kG' || medida === 'kG/ha' || medida === 'Kg' || medida === 'Kg/ha') {
        if (quantidade >= 1000) {
            return {
                quantidade_convertida: Number((quantidade / 1000).toFixed(2)),
                medida_convertida: 't'
            }
        }
    }
    if (medida === 'g' || medida === 'G' || medida === 'g/ha' || medida === 'G/ha') {
        if (quantidade >= 1000) {
            return {
                quantidade_convertida: Number((quantidade / 1000).toFixed(2)),
                medida_convertida: 'kg'
            }
        }
    }
    if (medida === 'L' || medida === 'l' || medida === 'L/ha' || medida === 'l/ha') {
        return {
            quantidade_convertida: Number(quantidade?.toFixed(2)),
            medida_convertida: 'L'
        }
    }
    if (medida === 'ml' || medida === 'ML' || medida === 'mL' || medida === 'Ml' || medida === 'ml/ha' || medida === 'ML/ha' || medida === 'mL/ha' || medida === 'Ml/ha') {
        if (quantidade >= 1000) {
            return {
                quantidade_convertida: Number((quantidade / 1000).toFixed(2)),
                medida_convertida: 'L'
            }
        }
    }
    if (medida === 'sementes' || medida === 'de sementes' || medida === 'sementes/ha') {
        if (quantidade >= 1000000) {
            return {
                quantidade_convertida: Number((quantidade / 1000000).toFixed(2)),
                medida_convertida: 'M de sementes'
            }
        }
    }

    return {
        quantidade_convertida: Number(quantidade?.toFixed(2)),
        medida_convertida: medida
    }
}

export function totalizarInsumoTalhao(insumos: InsumoLista[], data_unidades_medida: Item__UnidadeMedida[], total: number, medida_total: string) {
    // console.log("data_unidades_medida: ", data_unidades_medida)
    function normalizarQuantidade(quantidade: number, medida: string) {
        if (medida === 't' || medida === 'T' || medida === 'ton' || medida === 't/ha' || medida === 'T/ha' || medida === 'ton/ha') {
            return Number((Number(quantidade) * 1000).toFixed(2));
        }
        if (medida === 'g' || medida === 'G' || medida === 'g/ha' || medida === 'G/ha') {
            return Number((Number(quantidade) / 1000).toFixed(2));
        }
        if (medida === 'ml' || medida === 'ML' || medida === 'mL' || medida === 'Ml' || medida === 'ml/ha' || medida === 'ML/ha' || medida === 'mL/ha' || medida === 'Ml/ha') {
            return Number((Number(quantidade) / 1000).toFixed(2));
        }
        return Number(quantidade);
    }

    let insumos_com_medida = (insumos ?? []).map((item) => {
        let nome_medida = (data_unidades_medida ?? []).find(i => i.cod === item.cod_medida)?.nome ?? '';
        return {
            ...item,
            nome_medida: nome_medida,
            quantidade_normalizada: normalizarQuantidade(Number((item.quantidade)), nome_medida),
            medida_normalizada: normalizarMedidas(nome_medida),
        }
    });

    let totalizar = {
        quantidade_normalizada: (insumos_com_medida ?? []).reduce((acc, item) => Number(item.quantidade_normalizada) + acc, 0),
        medida_normalizada: insumos_com_medida[1]?.medida_normalizada ?? medida_total,
    }

    return {
        porcetagem: Number(((totalizar.quantidade_normalizada / total) * 100).toFixed(2)),
        quantidade_convertida: converterQuantidade(totalizar.quantidade_normalizada, totalizar.medida_normalizada).quantidade_convertida,
        medida_convertida: converterQuantidade(totalizar.quantidade_normalizada, totalizar.medida_normalizada).medida_convertida
    };
}

//#region Patrimonios
export type PatrimonioSaida = {
    cod_patrimonio: number,
    nome_patrimonio: string,
    tipo: string,
    lista_patrimonios: any[],
    area_utilizada: number,
    calculo_percorrido: number,
    media_area: number,
    filtro: string
};

export function patrimonios(data_atividades: Item__Atividades[]): PatrimonioSaida[] {

    function obterTipo(item: any): 'Odometro' | 'Horimetro' | 'Não informado' | 'Dados inválidos' {
        const odometro_inicial = item?.quilometragem_inicial ?? null;
        const odometro_final = item?.quilometragem_final ?? null;
        const horimetro_inicial = item?.horimetro_inicial ?? null;
        const horimetro_final = item?.horimetro_final ?? null;

        const temOdometro =
            odometro_inicial !== null || odometro_final !== null;

        const temHorimetro =
            horimetro_inicial !== null || horimetro_final !== null;

        // 1. Nenhuma informação
        if (!temOdometro && !temHorimetro) {
            return 'Não informado';
        }
        // 2. Dados misturados (erro de domínio)
        if (temOdometro && temHorimetro) {
            return 'Dados inválidos';
        }
        // 3. Odômetro
        if (temOdometro) {
            if (odometro_inicial === null || odometro_final === null) {
                return 'Dados inválidos';
            }
            return 'Odometro';
        }
        // 4. Horímetro
        if (temHorimetro) {
            if (horimetro_inicial === null || horimetro_final === null) {
                return 'Dados inválidos';
            }
            return 'Horimetro';
        }
        // fallback defensivo (não deveria acontecer)
        return 'Dados inválidos';
    }


    let add_info_atividade__01 = (data_atividades ?? []).map((i) => {
        return {
            ...i,
            andamentos: (i?.andamentos ?? []).map(j => {
                return {
                    ...j,
                    descricao: i.descricao,
                    cod_tipo_atividade: i.cod_tipo,
                    filtro_atividade: i.cod_tipo === 1 ? 'Planejadas' : 'Executadas'
                }
            })
        }
    })

    //@ts-ignore
    let apenas_andamentos__02 = (add_info_atividade__01 ?? []).map(i => i.andamentos)?.flat();

    let add_area__03 = (apenas_andamentos__02 ?? []).map((item) => {
        return {
            ...item,
            patrimonios: (item?.patrimonios ?? []).map(j => {
                return {
                    ...j,
                    area: item?.area,
                    descricao: item.descricao,
                    cod_tipo_atividade: item.cod_tipo_atividade,
                    filtro_atividade: item.cod_tipo_atividade === 1 ? 'Planejadas' : 'Executadas'
                }
            })
        }
    });

    let apenas_patrimonios__04 = (add_area__03 ?? []).map(i => i.patrimonios)?.flat();

    let add_tipo__05 = (apenas_patrimonios__04 ?? []).map(i => {
        return {
            ...i,
            tipo: obterTipo(i),
        }
    })

    let estrutura__06 = (add_tipo__05 ?? []).map((item) => {
        let calculo_inicial = item?.tipo === "Odometro" ? item?.quilometragem_inicial : item.horimetro_inicial;
        let calculo_final = item?.tipo === "Odometro" ? item?.quilometragem_final : item.horimetro_final;

        return {
            cod_patrimonio: item?.cod_patrimonio,
            nome_patrimonio: item?.patrimonio_nome,
            area_utilizada: item?.area,
            tipo: item?.tipo,
            cod_tipo_atividade: item?.cod_tipo_atividade,
            percorrido: Number(calculo_final) - Number(calculo_inicial)
        }
    });


    let agrupar_por_nome__07 = groupBy((estrutura__06 ?? []), 'cod_patrimonio');
    let estrutura__08 = (Object.entries(agrupar_por_nome__07) ?? []).map(([cod_patrimonio, lista_patrimonios]) => {
        let areas_utilizada = (lista_patrimonios ?? []).reduce((acc, item) => acc + Number(item?.area_utilizada), 0) ?? 0;
        let calculo_percorrido = (lista_patrimonios ?? []).reduce((acc, item) => acc + Number(item?.percorrido), 0) ?? 0;
        return {
            cod_patrimonio: Number(cod_patrimonio),
            nome_patrimonio: lista_patrimonios?.[0]?.nome_patrimonio,
            tipo: lista_patrimonios?.[0]?.tipo,
            lista_patrimonios: lista_patrimonios,
            area_utilizada: areas_utilizada,
            calculo_percorrido: calculo_percorrido,
            media_area: (areas_utilizada / calculo_percorrido),
            filtro: lista_patrimonios?.[0]?.cod_tipo_atividade === 1 ? 'Planejadas' : 'Executadas'
        }
    })


    return estrutura__08 ?? [];
}
//#endregion